import * as Lazy from './learnRoutes.lazy';

const learnRoutes = [
  {
    public: true,
    path: '/learn',
    renderer: props => <Lazy.LearnHub {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start',
    renderer: props => <Lazy.QuickStartHub {...props} />
  },
  {
    public: true,
    path: '/learn/strategies',
    renderer: props => <Lazy.StrategiesHub {...props} />
  },
  {
    public: true,
    path: '/learn/guides',
    renderer: props => <Lazy.GuidesHub {...props} />
  },
  {
    public: true,
    path: '/learn/sports',
    renderer: props => <Lazy.SportsHub {...props} />
  },
  {
    path: '/learn/beginners-guide-positive-expected-value-betting',
    renderer: (params = {}) => <Lazy.BeginnersGuideEvBetting {...params} />,
    public: true
  },
  {
    public: true,
    path: '/learn/quick-start/what-is-expected-value-sports-betting',
    renderer: props => <Lazy.WhatIsExpectedEv {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/calculate-ev-like-pro',
    renderer: props => <Lazy.CalculateEvLikePro {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/avoid-ev-missteps',
    renderer: props => <Lazy.AvoidEvMissteps {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/moneyline-bets',
    renderer: props => <Lazy.MoneylineBettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/point-spread-bets',
    renderer: props => <Lazy.PointSpreadBettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/over-under-bets',
    renderer: props => <Lazy.TotalOverUnderBettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/data-science-powers-ev-bets',
    renderer: props => <Lazy.DataSciencePowersEvBets {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/models-find-hidden-value',
    renderer: props => <Lazy.ModelsFindHiddenValue {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/spot-mispriced-odds-analytics',
    renderer: props => <Lazy.SpotMispricedOddsAnalytics {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/bankroll-management',
    renderer: props => <Lazy.BankrollManagement {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/bankroll-mistakes-avoid',
    renderer: props => <Lazy.BankrollMistakesToAvoid {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/kelly-criterion',
    renderer: props => <Lazy.KellyCriterion {...props} />
  },
  {
    public: true,
    path: '/learn/sports/nfl',
    renderer: props => <Lazy.NFLBettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/sports/college-football',
    renderer: props => <Lazy.CollegeFootballBettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/sports/mlb',
    renderer: props => <Lazy.MLBBettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/sports/nhl',
    renderer: props => <Lazy.NHLBettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/sports/nba',
    renderer: props => <Lazy.NBABettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/sports/wnba',
    renderer: props => <Lazy.WNBABettingGuide {...props} />
  },
  {
    public: true,
    path: '/learn/sports/mens-college-basketball',
    renderer: props => <Lazy.CollegeBasketballBettingGuide {...props} />
  },
  // Comparison pages
  {
    public: true,
    path: '/learn/comparisons/plusevbets-vs-oddsjam',
    renderer: props => <Lazy.PlusEVBetsVsOddsJam {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/oddsjam-alternative',
    renderer: props => <Lazy.OddsJamAlternative {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/rotowire-alternative',
    renderer: props => <Lazy.RotoWireAlternative {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/outlier-vs-plusevbets',
    renderer: props => <Lazy.OutlierVsPlusEVBets {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/plusevbets-vs-pikkit',
    renderer: props => <Lazy.PlusEVBetsVsPikkit {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/plusevbets-vs-bettingpros',
    renderer: props => <Lazy.PlusEVBetsVsBettingPros {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/plusevbets-vs-unabated',
    renderer: props => <Lazy.PlusEVBetsVsUnabated {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/plusevbets-vs-betql',
    renderer: props => <Lazy.PlusEVBetsVsBetQL {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/plusevbets-vs-action-network',
    renderer: props => <Lazy.PlusEVBetsVsActionNetwork {...props} />
  },
  {
    public: true,
    path: '/learn/comparisons/plusevbets-vs-sharp-app',
    renderer: props => <Lazy.PlusEVBetsVsSharpApp {...props} />
  },
  // Question-targeted content articles
  {
    public: true,
    path: '/learn/guides/can-you-make-money-sports-betting',
    renderer: props => <Lazy.CanYouMakeMoneySportsBetting {...props} />
  },
  {
    public: true,
    path: '/learn/guides/best-ev-betting-tools-2026',
    renderer: props => <Lazy.BestEVBettingTools2026 {...props} />
  },
  {
    public: true,
    path: '/learn/guides/why-most-ev-bets-lose',
    renderer: props => <Lazy.WhyMostEvBetsLose {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/what-is-vig-juice',
    renderer: props => <Lazy.WhatIsVigJuice {...props} />
  },
  {
    public: true,
    path: '/learn/guides/why-do-i-keep-losing',
    renderer: props => <Lazy.WhyDoIKeepLosing {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/avoid-getting-limited-sportsbooks',
    renderer: props => <Lazy.AvoidGettingLimitedSportsbooks {...props} />
  },
  {
    public: true,
    path: '/learn/guides/parlays-vs-straight-bets',
    renderer: props => <Lazy.ParlaysVsStraightBets {...props} />
  },
  {
    public: true,
    path: '/learn/guides/fanduel-vs-draftkings-odds',
    renderer: props => <Lazy.FanDuelVsDraftKingsOdds {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/how-much-bankroll-sports-betting',
    renderer: props => <Lazy.HowMuchBankrollSportsBetting {...props} />
  },
  // Tier 1 question-targeted pages
  {
    public: true,
    path: '/learn/quick-start/push-in-betting',
    renderer: props => <Lazy.PushInBetting {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/teaser-bets',
    renderer: props => <Lazy.TeaserBets {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/live-betting',
    renderer: props => <Lazy.LiveBetting {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/futures-betting',
    renderer: props => <Lazy.FuturesBetting {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/same-game-parlay',
    renderer: props => <Lazy.SameGameParlay {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/arbitrage-betting',
    renderer: props => <Lazy.ArbitrageBetting {...props} />
  },
  // Tier 2 question-targeted pages - Quick Start
  {
    public: true,
    path: '/learn/quick-start/how-betting-odds-work',
    renderer: props => <Lazy.HowBettingOddsWork {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/what-does-plus-200-mean',
    renderer: props => <Lazy.WhatDoesPlusTwoHundredMean {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/how-to-read-betting-lines',
    renderer: props => <Lazy.HowToReadBettingLines {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/cash-out-betting',
    renderer: props => <Lazy.CashOutBetting {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/odds-boosts',
    renderer: props => <Lazy.OddsBoosts {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/compare-sportsbook-odds',
    renderer: props => <Lazy.CompareSportsbookOdds {...props} />
  },
  {
    public: true,
    path: '/learn/quick-start/key-numbers-nfl',
    renderer: props => <Lazy.KeyNumbersNFL {...props} />
  },
  // Tier 2 question-targeted pages - Guides
  {
    public: true,
    path: '/learn/guides/track-your-bets',
    renderer: props => <Lazy.TrackYourBets {...props} />
  },
  {
    public: true,
    path: '/learn/guides/closing-line-value',
    renderer: props => <Lazy.ClosingLineValueExplained {...props} />
  },
  {
    public: true,
    path: '/learn/guides/when-to-bet-early-vs-late',
    renderer: props => <Lazy.WhenToBetEarlyVsLate {...props} />
  },
  {
    public: true,
    path: '/learn/guides/how-to-research-bets',
    renderer: props => <Lazy.HowToResearchBets {...props} />
  },
  // Tier 2 question-targeted pages - Strategies
  {
    public: true,
    path: '/learn/strategies/build-betting-model',
    renderer: props => <Lazy.BuildBettingModel {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/home-field-advantage',
    renderer: props => <Lazy.HomeFieldAdvantage {...props} />
  },
  // Tier 1 SEO content pages - Why questions
  {
    public: true,
    path: '/learn/guides/why-parlays-always-lose',
    renderer: props => <Lazy.WhyParlaysAlwaysLose {...props} />
  },
  // Tier 1 SEO content pages - Vs comparisons
  {
    public: true,
    path: '/learn/guides/moneyline-vs-spread',
    renderer: props => <Lazy.MoneylineVsSpread {...props} />
  },
  {
    public: true,
    path: '/learn/guides/props-vs-game-bets',
    renderer: props => <Lazy.PropsVsGameBets {...props} />
  },
  // Graduating Bettor decision pages (GH #136, #137, #139)
  {
    public: true,
    path: '/learn/guides/cfb-moneyline-vs-spread-big-favorites',
    renderer: props => <Lazy.CfbMoneylineVsSpreadBigFavorites {...props} />
  },
  {
    public: true,
    path: '/learn/guides/saturday-clv-workflow',
    renderer: props => <Lazy.SaturdayClvWorkflow {...props} />
  },
  {
    public: true,
    path: '/learn/guides/ncaaf-vs-nfl-market-differences',
    renderer: props => <Lazy.NcaafVsNflMarketDifferences {...props} />
  },
  // Tier 1 SEO content pages - Strategy deep dives
  {
    public: true,
    path: '/learn/strategies/buying-points-strategy',
    renderer: props => <Lazy.BuyingPointsStrategy {...props} />
  },
  {
    public: true,
    path: '/learn/strategies/alternate-lines-strategy',
    renderer: props => <Lazy.AlternateLinesStrategy {...props} />
  },
  // Graduating Bettor decision page (GH #138)
  {
    public: true,
    path: '/learn/strategies/multi-book-bankroll-rules',
    renderer: props => <Lazy.MultiBookBankrollRules {...props} />
  },
  // How to Bet on [Sport] beginner guides
  {
    public: true,
    path: '/learn/guides/how-to-bet-on-nfl',
    renderer: props => <Lazy.HowToBetOnNFL {...props} />
  },
  {
    public: true,
    path: '/learn/guides/how-to-bet-on-nba',
    renderer: props => <Lazy.HowToBetOnNBA {...props} />
  },
  {
    public: true,
    path: '/learn/guides/how-to-bet-on-wnba',
    renderer: props => <Lazy.HowToBetOnWNBA {...props} />
  },
  {
    public: true,
    path: '/learn/guides/how-to-bet-on-mlb',
    renderer: props => <Lazy.HowToBetOnMLB {...props} />
  },
  {
    public: true,
    path: '/learn/guides/how-to-bet-on-nhl',
    renderer: props => <Lazy.HowToBetOnNHL {...props} />
  },
  {
    public: true,
    path: '/learn/guides/how-to-bet-on-college-football',
    renderer: props => <Lazy.HowToBetOnCollegeFootball {...props} />
  },
  {
    public: true,
    path: '/learn/guides/how-to-bet-on-college-basketball',
    renderer: props => <Lazy.HowToBetOnCollegeBasketball {...props} />
  },
  // One page each: the old /learn/glossary/<term> and /learn/states/<slug>
  // URLs 301 to anchors on these (#276, app/url_canonical.py).
  { public: true, path: '/learn/glossary', renderer: props => <Lazy.GlossaryHub {...props} /> },
  { public: true, path: '/learn/states', renderer: props => <Lazy.StatesHub {...props} /> },
];

export default learnRoutes;
